import React, { useState } from "react";
import { browserHistory, Link } from "react-router";
import moment from "moment";
import { Checkbox, TableCell, TableRow, Tooltip, } from "@material-ui/core";
import { VisibilityOutlined, DeleteOutline, Edit } from '@material-ui/icons';
import RevertIcon from "../../../assets/images/Revert_Icon.svg"
import { checkPermission } from "../../../utils_v2";
import { displayDateFormat } from "../../../../constants";

const EngineFamilyList = ({ item, index, onEditFn, onDelete, onRevert, toggleBulkOps, bulkIds }) => {

	const [showMore, setShowMore] = useState({});
		const toggleDescription = (field) => {
			setShowMore({
				...showMore,
				[field]: !showMore[field]
			})
		}
const stripHtml = (html) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};

    return (
        <>
            <TableRow style={{cursor:'pointer'}} onClick={(e) => {browserHistory.push(`/config-data/engineFamily/View/${item.id}`)}}  key={index} className={item?.deleted_at ? "grey-out" : ''} >
                <TableCell>
					<ul className="list-inline flex-centered" style={{width:'130px'}}>
						{ checkPermission('config_data', 'engine_family', 'D') &&	<li className="list-inline-item hover-inline last-icon" onClick={(e) => { e.stopPropagation();}}>
						<Checkbox checked={bulkIds.includes(item?.id)} onChange={(e) => { toggleBulkOps(item, e.target.checked) }} color="primary" size="small" />
						</li>}
						<li className="list-inline-item hover-inline last-icon" style={{marginTop:"5px"}} onClick={(e) => {e.preventDefault(); e.stopPropagation()}}>
							<Tooltip title='Veiw' arrow><Link to={`/config-data/engineFamily/View/${item.id}`} fontSize="small" classname="back-icon" style={{ color: "#3f51b5" }} ><VisibilityOutlined color="primary" fontSize="small" /></Link></Tooltip>
						</li>
						{!item?.deleted_at  && checkPermission('config_data', 'engine_family', 'U') ?
							<li className="list-inline-item hover-inline" onClick={(e) => {e.preventDefault();e.stopPropagation();onEditFn()}}>
								<Tooltip title='Edit' arrow><Edit color="primary" fontSize="small" /></Tooltip>
							</li>
							: null}
						{item?.deleted_at && checkPermission('config_data', 'engine_family', 'RVT')?
							<li className="list-inline-item hover-inline" >
								<Tooltip title='Revert' arrow>
									<img
										src={RevertIcon}
										alt="Revert Icon"
										onClick={(e) => {e.preventDefault();e.stopPropagation();onRevert({ modal: true, data: item?.id })}}
										style={{ width: "1rem", height: "1rem", cursor: 'pointer', fontSize:"1.25rem", margin:'4px' }}
										className="last-icon"
									/>
								</Tooltip>
							</li>
							: null}
						{!item?.deleted_at && checkPermission('config_data', 'engine_family', 'D') ?
							<li className="list-inline-item hover-inline" onClick={(e) => {e.preventDefault();e.stopPropagation();onDelete({ modal: true, data: item, })}}>
								<Tooltip title='Delete' arrow><DeleteOutline color="secondary" fontSize="small" /></Tooltip>
							</li>
							: null}
					</ul>
				</TableCell>
                <TableCell><div style={{ width: '150px' }}>{item?.name || '--'}</div></TableCell>
                <TableCell><div style={{ width: '150px' }}>{item?.manufacturer?.name || '--'}</div></TableCell>
                <TableCell>
                    <div style={{ width: '140px' }}>
                        {item?.created_by?.name || '--'}
                        {item?.created_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.created_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '140px' }}>
                        {item?.updated_by?.name || '--'}
                        {item?.updated_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.updated_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
				<TableCell onClick={(e) => e.stopPropagation()}>
					{item?.remarks && item?.remarks?.length > 30 ? (
						<div style={{ width: '200px' }}>
							{showMore[item?.field] ? (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
								</span>
							) : (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
								</span>
							)}
						</div>
					) : (
						<div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
					)}
				</TableCell>
            </TableRow>
        </>
    )
}

export default EngineFamilyList